import React from 'react';

export const SidebarProfile = ({ user }) => (
  <ul className="nav">
    <li className="nav-profile">
      <div className="cover with-shadow" />
      <div className="info">
        {user.name}
        <small>Administrador</small>
      </div>
    </li>
  </ul>
);

export default SidebarProfile;
